var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCoinsStack = function SvgCoinsStack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.71484 9.42773V19.7134C7.71484 21.5992 11.1434 23.142 15.4291 23.142C19.7148 23.142 23.1434 21.5992 23.1434 19.7134V9.42773",
    stroke: "currentColor",
    fill: "transparent",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4291 12.8571C19.6896 12.8571 23.1434 11.3221 23.1434 9.42857C23.1434 7.53502 19.6896 6 15.4291 6C11.1686 6 7.71484 7.53502 7.71484 9.42857C7.71484 11.3221 11.1686 12.8571 15.4291 12.8571Z",
    stroke: "currentColor",
    fill: "transparent",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1434 14.5723C23.1434 16.458 19.7148 18.0008 15.4291 18.0008C11.1434 18.0008 7.71484 16.458 7.71484 14.5723",
    stroke: "currentColor",
    fill: "transparent",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2574 2.57113C13.2543 1.33491 10.9226 0.737041 8.57171 0.856842C4.30314 0.856842 0.857422 2.3997 0.857422 4.28541C0.857422 5.29684 1.85171 6.20541 3.42885 6.85684",
    stroke: "currentColor",
    fill: "transparent",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.42885 17.1423C1.85171 16.4909 0.857422 15.5823 0.857422 14.5709V4.28516",
    stroke: "currentColor",
    fill: "transparent",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.42885 11.9992C1.85171 11.3477 0.857422 10.4392 0.857422 9.42773",
    stroke: "currentColor",
    fill: "transparent",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgCoinsStack;